import axios from "axios";
import dictionary from "../dictionary";
import functions from "../functions";

const apiHost = dictionary.apiHost;

/** Endpoints that are reachable before anyone has signed in. */
/** Reachable before anyone is signed in. These names are the routes the API
 *  actually answers on — the old list held two that do not exist. */
const WHITELIST = ["login", "system/user/forgot_password", "password/reset"];

const apiCall = async (endpoint, data) => {
  const isWhitelisted = WHITELIST.includes(endpoint);

  // Read the token per call. It used to be read once when this module loaded,
  // which meant the app kept using whatever was there at start-up: sign in and
  // every request still went out unauthenticated, sign out and they kept going
  // out with the old token.
  const token = functions.token();

  if (!isWhitelisted && !token) {
    // Nobody is signed in. Say so plainly — "conn" reads as a network problem
    // and pages showed "check your connection" to someone who was simply
    // logged out — and send them to the login page.
    functions.endSession();
    return {
      status: "auth",
      message: "Your session has ended. Please sign in again.",
      details: { message: "Login required to access this resource.", content: false },
    };
  }

  try {
    const response = await axios.post(apiHost + endpoint, data, {
      headers: {
        Authorization: token ? "Bearer " + token : undefined,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    // A rejected session and an unreachable server are different problems and
    // used to be reported identically. Only the first should sign anyone out.
    if (error.response && (error.response.status === 401 || error.response.status === 419)) {
      functions.endSession();
      return {
        status: "auth",
        message: "Your session has ended. Please sign in again.",
        details: { message: "Login required to access this resource.", content: false },
      };
    }

    return {
      status: "conn",
      message: "Server connection error occurred!",
      details: { message: "Contacting server....", content: false },
    };
  }
};

export default apiCall;
